import Search from './../components/Search.vue'
import Services from './../components/Services.vue'
import Extras from './../components/Extras.vue'
import Info from './../components/Info.vue'
import Summary from './../components/Summary.vue'
import Success from './../components/Success.vue'
import PaypalError from './../components/PaypalError.vue'
import PaypalPlus from './../components/PaypalPlus.vue'
import PaypalPlusV2 from './../components/PaypalPlusV2.vue'
import Stripe from './../components/Stripe.vue'

export default [
	{ path:'/', component: Search },
	{ path:'/services', component: Services },
	{ path:'/extras', component: Extras },
	{ path:'/information', component: Info },
	{ path:'/summary', component: Summary },
	{ path:'/success', component: Success },
	{ path:'/error', component: PaypalError },
	{ path:'/paypal-plus', component: PaypalPlus },
  { path:'/paypal', component: PaypalPlusV2 },
	{ path:'/stripe-checkout', component: Stripe },
];
